import React from 'react';

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import {ClientProduct} from "../index";

const Product = () => {

  return (
    <>
      <div className="pt-12 px-5 max-w-[1320px] w-full mx-auto">
        <Navbar isYellowLogo={true}/>
      </div>

      <ClientProduct isLanding={true} />

      <Footer />
    </>
  )
};

export default Product;
